// import axios from 'axios'
// import { ACCESS_TOKEN, TENANT_ID, TENANT_CODE, USER_NAME, USER_ID, DATA_ROLE_CODES, EMP_ID, EMP_NAME, ENTERPRISE_IDS } from './mutation-types'

// // 创建 axios 实例
// const service = axios.create({
//   baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
//   timeout: 30000 // 请求超时时间
// })

// service.interceptors.request.use(
//   config => {
//     // 新增全局参数
//     var data = config.data
//     const name = sessionStorage.getItem(EMP_NAME) ? sessionStorage.getItem(USER_NAME) : sessionStorage.getItem(USER_NAME)
//     const empId = sessionStorage.getItem(EMP_ID) ? sessionStorage.getItem(EMP_ID) : sessionStorage.getItem(USER_ID)
//     if (config.url.indexOf('login') === -1) {
//       let cp = ''
//       if (data && data.createdPerson) {
//         cp = data.createdPerson
//       } else {
//         cp = sessionStorage.getItem(USER_NAME)
//       }
//       let cpid = ''
//       if (data && data.createdPersonId) {
//         cpid = data.createdPersonId
//       } else {
//         cpid = empId
//       }
//       let tc = ''
//       if (data && data.tenantCode) {
//         tc = data.tenantCode
//       } else {
//         tc = sessionStorage.getItem(TENANT_CODE)
//       }
//       let ti = ''
//       if (data && data.tenantId) {
//         ti = data.tenantId
//       } else {
//         ti = sessionStorage.getItem(TENANT_ID)
//       }
//       const enterpriseIdStr = sessionStorage.getItem(ENTERPRISE_IDS)
//       let enterpriseIds = []
//       if (enterpriseIdStr) {
//         enterpriseIds = JSON.parse(enterpriseIdStr)
//       }
//       data = {
//         ...data, tenantId: ti, tenantCode: tc, createdPerson: cp, createdPersonId: cpid, lastUpdatedPerson: name, lastUpdatedPersonId: empId, userId: sessionStorage.getItem(USER_ID), dataRoleCodes: sessionStorage.getItem(DATA_ROLE_CODES), enterpriseIds: enterpriseIds
//       }
//     }
//     config.data = data
//     const token = sessionStorage.getItem(ACCESS_TOKEN)
//     if (token) {
//       config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
//     }
//     return config
//   },
//   err => {
//     // window.location.href = '/index'
//     return Promise.reject(err)
//   })

// // http response 拦截器
// service.interceptors.response.use(
//   response => {
//     //拦截响应，做统一处理 
//     return response.data
//   },
//   //接口错误状态处理，也就是说无响应时的处理
//   error => {
//     // window.location.href = '/index'
//     return Promise.reject(error.response.status) // 返回接口返回的错误信息
//   })

// export {
//   service as axios
// }


/**
 * 封装 axios 请求模块
 */
import axios from 'axios'
import qs from "qs";
 
 const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // 基础路径
   // 自定义后端返回的原始数据
   // data: 后端返回的原始数据，说白了就是 JSON 格式的字符串
 })
 // 请求拦截器
 // Add a request interceptor
 service.interceptors.request.use(config => {
  // 放置发送请求前，需要修改的内容
  // 验证时候有token，有则加入请求头部
  if (sessionStorage.getItem('ACCESS_TOKEN')) {
    config.headers.Token = sessionStorage.getItem('ACCESS_TOKEN');
  }
  // if (config["_cancelToken"]) {
  //   config.cancelToken = new config["_cancelToken"](function executor(c) {
  //     // executor 函数接收一个 cancel 函数作为参数
  //     cancelToken = c;
  //   });
  // }
  if (
    config.headers["Content-Type"] === "application/x-www-form-urlencoded"
  ) {
    config.transformRequest = [
      function(data) {
        data = qs.stringify(data);
        return data;
      }
    ];
  }
  // // // 返回请求数据
  // if (
  //   config.method === "post" ||
  //   config.method === "delete" ||
  //   config.method === "put"
  // ) {
  //   config.transformRequest = [
  //     function (data) {
  //       if (Taro.getStorageSync("token")) {
  //         data.token = Taro.getStorageSync("token");
  //       }
  //       data = qs.stringify(data);
  //       return data;
  //     }
  //   ];
  // } else {
  //   if (Taro.getStorageSync("token")) {
  //     config.params.token = Taro.getStorageSync("token");
  //   }
  // }

  return config;
},
error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});
 
 // 响应拦截器
export {
  service as axios
}
